import React from "react";
import ctl from "@netlify/classnames-template-literals";

import { Ntext } from "components";

const TestimonialCard = ({ driverName, testimony, driverCompany }) => {
  return (
    <article className={cardStyle}>
      <Ntext
        color="primary-100"
        value={`${testimony}`}
        className="md:!leading-[32px] !-tracking-[0.8px] w-[284px] md:w-[344px]"
        variant="text4lite"
      />
      <div className="flex items-baseline">
        <Ntext
          color="n-yellow3"
          value={driverName + ","}
          className="!font-bold"
          variant="text3"
        />
        &nbsp;
        <Ntext
          color="n-yellow3"
          value={driverCompany}
          className="!font-medium"
          variant="text3"
        />
      </div>
    </article>
  );
};

const cardStyle = ctl(`
  flex
  flex-col
  h-[360px]
  lg:h-[320px]
  justify-between
  rounded-3xl
  bg-n-grey8
  mr-6
  p-8
`);

export { TestimonialCard };
